import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { Tab, Tabs, TabsProps } from '~c/components/base/tabs';

interface Props {
  className?: string;
}

const TabsDemo: React.FC<Props> = ({ className }) => {
  const [value, setValue] = React.useState('tab-1');

  const handleChange: TabsProps['onChange'] = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={className}>
      <Tabs value={value} onChange={handleChange} variant="fullWidth">
        <Tab value="tab-1" label="Item 1" />
        <Tab value="tab-2" label="Item 2" />
        <Tab value="tab-3" label="Item 3" />
        <Tab value="tab-4" label="Item 4" />
        <Tab value="tab-5" label="Item 5" />
        <Tab value="tab-6" label="Item 6" />
        <Tab value="tab-7" label="Item 7" />
      </Tabs>
    </div>
  );
};

export default muiStyled(TabsDemo)(({ theme }) => css``);
